import {SimpleModule} from 'ca-middleware';
export class ModuleThematicMap extends SimpleModule {

    constructor() {
        super();
    }

    public configureView() {
        this.addComponent('LayoutThematicMap');
        // 地图全局共享变量

    }

    public configureService() {

    }
}
